import React from "react";

export default function KeyTakeawaysBox({ title = "Key takeaways", items = [] }) {
  if (!items.length) return null;

  return (
    <section className="mb-10 rounded-3xl border border-[#17A6A4]/35 bg-[#EAFBFC] p-5 shadow-sm md:p-6" aria-label={title}>
      <p className="text-xs font-black uppercase tracking-[0.24em] text-[#168F92]">{title}</p>
      <ul className="mt-4 space-y-3">
        {items.slice(0, 5).map((item, index) => (
          <li key={`${item}-${index}`} className="flex gap-3 text-base font-semibold leading-7 text-[#10233E]">
            <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-[#17A6A4]" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}